export default "__VITE_ASSET__DMUtehTK__"